import Catalyst from '@Services/Catalyst';

export const trackAdobeAnalyticsError = (formError) => {
  if (formError) {
    Catalyst.trackError(
      {
        message: formError,
        component: 'History',
      },
      'fe-'
    );
  }
};

export const trackAdobeAnalyticsPage = (route) => {
  Catalyst.trackPage(route);
};

export const trackConversionDriverClick = () => {
  Catalyst.trackConversionDriverClick('history:savesearch:sign-in');
};
